import React, { createContext, useState } from "react";
import { CarrierI, RateType } from "../redux/approvals/approvalsTypes";

type RateEntryContextI = {
  isTable: boolean;
  setIsTable: (value: boolean) => void;
  active: number;
  setActive: (value: number) => void;
  rateType: RateType | "";
  setRateType: (value: RateType | "") => void;
  isOpenModal: boolean;
  setIsOpenModal: (value: boolean) => void;
  carrier: CarrierI | null;
  setCarrier: (value: CarrierI | null) => void;
  handleNext: () => void;
  handlePrev: () => void;
  onCloseModal: () => void;
}

export const RateEntryContext = createContext<RateEntryContextI>({
  isTable        : false,
  setIsTable     : () => null,
  active         : 0,
  setActive      : () => null,
  rateType       : "",
  setRateType    : () => null,
  isOpenModal    : false,
  setIsOpenModal : () => null,
  carrier        : null,
  setCarrier     : () => null,
  handleNext     : () => null,
  handlePrev     : () => null,
  onCloseModal   : () => null,
});

export const RateEntryProvider: React.FC = ({ children }) => {
  const [ isTable, setIsTable ] = useState(false);
  const [ carrier, setCarrier ] = useState<CarrierI | null>(null);
  const [ active, setActive ] = useState(0);
  const [ rateType, setRateType ] = useState<RateType | "">("");
  const [ isOpenModal, setIsOpenModal ] = useState(false);

  const handleNext = () => {
    setActive(active + 1);
  };

  const handlePrev = () => {
    setActive(active - 1);
  };

  const onCloseModal = () => {
    setRateType("");
    setIsTable(false);
    setCarrier(null);
    setActive(0);
    setIsOpenModal(false);
  };

  return (
    <RateEntryContext.Provider
      value={{
        isTable,
        setIsTable,
        active,
        setActive,
        rateType,
        setRateType,
        handleNext,
        handlePrev,
        isOpenModal,
        setIsOpenModal,
        carrier,
        setCarrier,
        onCloseModal,
      }}
    >
      {children}
    </RateEntryContext.Provider>
  );
};
